/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CompanyWebhookDeliveryState {
  Pending = "pending",
  Delivered = "delivered",
  Failed = "failed",
  Exhausted = "exhausted",
  Superseded = "superseded",
}

export function instanceOfCompanyWebhookDeliveryState(value: any): boolean {
  for (const key in CompanyWebhookDeliveryState) {
    if (
      Object.prototype.hasOwnProperty.call(CompanyWebhookDeliveryState, key)
    ) {
      if (
        CompanyWebhookDeliveryState[
          key as keyof typeof CompanyWebhookDeliveryState
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CompanyWebhookDeliveryStateFromJSON(
  json: any,
): CompanyWebhookDeliveryState {
  return CompanyWebhookDeliveryStateFromJSONTyped(json, false);
}

export function CompanyWebhookDeliveryStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyWebhookDeliveryState {
  return json as CompanyWebhookDeliveryState;
}

export function CompanyWebhookDeliveryStateToJSON(
  value?: CompanyWebhookDeliveryState | null,
): any {
  return value as any;
}

export function CompanyWebhookDeliveryStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CompanyWebhookDeliveryState {
  return value as CompanyWebhookDeliveryState;
}
